export enum ExecutorBehavior {
  DEFAULT = 0,
  LOOP = 1,
  BRANCH = 2,
  WAIT = 3,
}
